import { css, styled } from 'styled-components';

export const StyleModalContainer = styled.div``;

export const StyleAddressInfo = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 16px;
  color: var(--pcm-body-color);
  overflow: hidden;
  position: relative;
  top: -6px;
  .copied-0 {
    svg {
      /* opacity: 0.8 !important; */
    }
  }
`;

export const StyleWalletInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: var(--pcm-rounded-lg);
  padding: 10px 14px;
  margin-bottom: 30px;
  color: var(--pcm-body-color);
  background: var(--pcm-body-background-tertiary);
  position: relative;
  gap: 10px;
`;

interface StyleSwitchNetworkProps {
  selected?: boolean;
}
export const StyleWalletInfoLeft = styled.div<StyleSwitchNetworkProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 26px;
  flex: 1;
  overflow: hidden;
  cursor: ${(props) => (props.selected ? 'pointer' : 'default')};
`;

export const StyleWalletIcon = styled.img`
  width: 22px;
  height: 22px;
`;

export const StyleWalletText = styled.div`
  font-size: 14px;
  display: flex;
  gap: 8px;
  align-items: center;
  position: relative;
  svg {
    position: relative;
    width: 10px;
    top: 1px;
  }
`;

export const StyleWalletInfoRight = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const StyleBalance = styled.div`
  font-size: 14px;
  color: var(--pcm-body-color-secondary);
  /* 强制不换行 */
  white-space: nowrap;
`;

export const StyleRefreshIcon = styled.div`
  cursor: pointer;
`;

export const StyleActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-bottom: 1px solid var(--pcm-button-border-color);
  padding-bottom: 30px;
`;

export const StyleActionIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 10px;
`;

export const StyleActionText = styled.div`
  font-size: 16px;
  color: var(--pcm-body-color);
`;

export const StyleFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 10px;
`;

export const StyleFooterLabel = styled.div`
  font-size: 14px;
  cursor: pointer;
`;

export const WalletIconWrapper = styled.div`
  height: 26px;
  width: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 100%;
  }
`;

export const StyleTextButton2 = styled.div<{ $disconnectLoading?: boolean }>`
  color: var(--pcm-body-color-secondary);
  svg {
    color: var(--pcm-body-color-secondary);
  }
  opacity: 1;
  cursor: pointer;

  &:hover {
    color: var(--pcm-primary-button-bankground);
    svg {
      color: var(--pcm-primary-button-bankground);
    }
  }

  ${({ $disconnectLoading }) =>
    $disconnectLoading &&
    css`
      opacity: 0.6;
      pointer-events: none;
      &:hover {
        color: var(--pcm-body-color-secondary);
        svg {
          color: var(--pcm-body-color-secondary);
        }
      }
    `}
`;

export const StyleChainName = styled.div`
  font-size: 14px;
  color: var(--pcm-body-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TitleContainer = styled.div`
  pointer-events: all;
  position: absolute;
  left: 24px;
  bottom: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyleDisconnectContent = styled.div`
  position: relative;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 3px;
`;

export const StyleDisconnectLoading = styled.div`
  position: absolute;
  width: 16px;
  height: 16px;
  top: 50%;
  left: 11px;
  transform: translate(-50%, -50%);
`;

export const StyleShareContent = styled.div`
  position: relative;
  top: -1px;
  left: -4px;
  height: 24px;
  display: flex;
  align-items: center;
`;
